import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useApiStatus from '../hooks/useApiStatus';

// The standalone scorecards need no backend at all, so they are the useful
// thing to offer when the API is down rather than a dead dashboard.
const OFFLINE_GAMES = [
  { label: 'Five Crowns', path: '/five-crowns' },
  { label: 'Phase 10', path: '/phase-10' }
];

// Routes that either already work offline or run their own banner, so a second
// one on top would be noise.
function isSuppressed(pathname) {
  return (
    OFFLINE_GAMES.some((g) => pathname.startsWith(g.path)) ||
    pathname.startsWith('/game/') ||
    pathname.endsWith('/tv')
  );
}

export default function OfflineNotice() {
  const { online, checked } = useApiStatus();
  const location = useLocation();
  const navigate = useNavigate();

  if (!checked || online || isSuppressed(location.pathname)) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-amber-600 text-white shadow-lg">
      <div className="max-w-3xl mx-auto px-4 py-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-sm font-medium">
        <span>Can't reach the server — you can still keep score offline.</span>
        {OFFLINE_GAMES.map((game) => (
          <button
            key={game.path}
            onClick={() => navigate(game.path)}
            className="underline underline-offset-2 hover:no-underline"
          >
            {game.label}
          </button>
        ))}
      </div>
    </div>
  );
}
